(function () {
  var popup = document.querySelector('[data-fondlyme-discount-popup]');

  if (!popup) {
    return;
  }

  var copyButton = popup.querySelector('[data-fondlyme-discount-copy]');
  var status = popup.querySelector('[data-fondlyme-discount-status]');
  var closeButtons = popup.querySelectorAll('[data-fondlyme-discount-close]');
  var copiedTimer;
  var successMessage = document.querySelector('.newsletter-form__message--success');
  var shouldAutoOpen =
    popup.dataset.autoOpen === 'true' ||
    new URLSearchParams(window.location.search).get('customer_posted') === 'true' ||
    window.location.hash === '#ContactFooter-success' ||
    Boolean(successMessage);

  function openPopup() {
    popup.hidden = false;
    document.body.classList.add('fondlyme-discount-popup-open');

    if (copyButton) {
      copyButton.focus({ preventScroll: true });
    }
  }

  function closePopup() {
    popup.hidden = true;
    document.body.classList.remove('fondlyme-discount-popup-open');
  }

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      document.body.removeChild(textarea);
    }
  }

  function copyDiscountCode() {
    var code = copyButton.dataset.discountCode || 'FMLV9';
    var copyAction = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(code)
      : fallbackCopy(code);

    copyAction
      .then(function () {
        window.clearTimeout(copiedTimer);
        copyButton.classList.remove('is-copied');
        void copyButton.offsetWidth;
        copyButton.classList.add('is-copied');
        status.textContent = 'Copied: ' + code;
        status.classList.add('is-visible');

        copiedTimer = window.setTimeout(function () {
          copyButton.classList.remove('is-copied');
          status.classList.remove('is-visible');
        }, 1800);
      })
      .catch(function () {
        status.textContent = 'Select and copy the code: ' + code;
        status.classList.add('is-visible');
      });
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  if (copyButton) {
    copyButton.addEventListener('click', copyDiscountCode);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }
  });

  if (shouldAutoOpen) {
    openPopup();
  }
})();
